export default __webpack_public_path__ + "static/media/risk_high.89f1da33.svg";